import { EnhancedHeader } from '@/components/EnhancedHeader';
import { CrossSportAnalytics } from '@/components/CrossSportAnalytics';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { PredictionContests } from '@/components/PredictionContests';
import { Activity, Trophy } from 'lucide-react';

export default function Analytics() {
  return (
    <div className="min-h-screen bg-gradient-dark">
      <EnhancedHeader />
      <main className="container mx-auto px-4 py-8">
        <div className="mb-8">
          <h1 className="text-3xl font-bold mb-2">Analytics & Contests</h1>
          <p className="text-muted-foreground">
            Deep insights and community competitions
          </p>
        </div>

        <Tabs defaultValue="analytics" className="space-y-6">
          <TabsList className="grid w-full grid-cols-2 h-auto">
            <TabsTrigger value="analytics" className="flex items-center gap-2 py-3">
              <Activity className="h-4 w-4" />
              Cross-Sport Analytics
            </TabsTrigger>
            <TabsTrigger value="contests" className="flex items-center gap-2 py-3">
              <Trophy className="h-4 w-4" />
              Prediction Contests
            </TabsTrigger>
          </TabsList>

          <TabsContent value="analytics">
            <CrossSportAnalytics />
          </TabsContent>

          <TabsContent value="contests">
            <PredictionContests />
          </TabsContent>
        </Tabs>
      </main>
    </div>
  );
}
